import React from "react"
import {Box, Columns, Heading, Table} from "react-bulma-components";
import MovementRow from "../Movement/MovementRow";
import {movementCost} from "../../utils";
import {createSetDataFreshAction, createSetMovementsDataAction} from "../../actions/dataActions";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import {useDispatch} from "react-redux";

export default function MovementSection({movements, serializerField=false, rateData, dataFresh, endpoint, typeData, movementTypeObjects, driverData, driverObjects, departments, departmentObjects}){
    const dispatch = useDispatch();

    const movementRateObjects = rateData.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});


    const onChange = (e, index) => {
        let newMovement = {...movements.results[index], [e.target.name]:e.target.value}
        newMovement = movementCost(newMovement)
        movements.results[index] = newMovement;
        dispatch(createSetMovementsDataAction(movements.results))
    }

    const onRateChange = (e, index) => {
        let toUpdate ={
            target: {
                name: e.target.name,
                value: movementRateObjects[e.target.value]
            }
        }
        onChange(toUpdate, index);
    }

    const onComplete = (data) => {
        const conf = {
            url: endpoint+"movementcomplete/"+data.id,
            method: "put",
            data: data
        };
        axios(conf).then((res) => {
            dispatch(createSetDataFreshAction(dataFresh+1))
        });
    };

    const onDelete = (data) => {
        const conf = {
            url: endpoint+"movement/"+data.id,
            method: "delete"
        }
        axios(conf).then((res) => {
            dispatch(createSetDataFreshAction(dataFresh+1));
        }).catch(() => {
            NotificationManager.error("There was an error deleting that movement");
        })
    };
    const onQuoteToMovement = (data) => {
        const url = endpoint+"movementquote/"+data.id;
        const conf = {
            url: url,
            method: "put"
        }
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1))
        })
    };

    const onSave = (data) => {
        const conf = {
            url: endpoint+"movement/"+data.id,
            method: "put",
            data: data
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(()=> {
            NotificationManager.error("There was an error saving the movement")
        })
    };

    const mapReturn = (movement, index) => (
        <MovementRow
            movement={movement}
            onDelete={onDelete}
            onChange={onChange}
            index={index}
            onSave={onSave}
            rateOptions={rateData}
            onRateChange={onRateChange}
            view={"QUOTE"}
            quoteToMovement={onQuoteToMovement}
            onComplete={onComplete}
            movementTypes={typeData}
            movementTypeObjects={movementTypeObjects}
            endpoint={endpoint}
            isJob={true}
            disabled={movement.completed}
            driverObjects={driverObjects}
            driverOptions={driverData}
            departments={departments}
            departmentObjects={departmentObjects}
        />
    )

    return (
        <Box>
            <Columns>
                <Columns.Column>
                    <Heading>Movements</Heading>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Table
                        size={"fullwidth"}
                    >
                        <thead>
                        <tr>
                            <th>Movement No.</th>
                            <th>Customer Charger</th>
                            <th>Vehicle To Move</th>
                            <th>Start Address</th>
                            <th>End Address</th>
                            <th>Delivery Date</th>
                            <th>Creator</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {movements ?
                            serializerField ?
                                movements.map(((movement, index) => (mapReturn(movement, index)))) :
                                movements.results.map(((movement, index) => (mapReturn(movement, index)))) :
                            <tr></tr>}
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </Box>
    )


}